<template>
	<v-app>
		<app-toolbar></app-toolbar>

		<v-content app>
			<transition name="fade" mode="out-in">
				<router-view></router-view>
			</transition>
			<app-loading :loading="loading"></app-loading>
		</v-content>

		<app-notifier :notifier="notifier"></app-notifier>

		<app-footer></app-footer>
	</v-app>
</template>

<script>
import AppToolbar from "@/components/AppToolbar";
import AppFooter from "@/components/AppFooter";

export default {
	components: {
		AppToolbar,
		AppFooter,
		"app-loading": require("@/components/AppLoading.vue").default,
		"app-notifier": require("@/mixins/notifier-mixin").default
	},
	computed: {
		loading() {
			return this.$store.state.loading;
		},
		notifier() {
			return this.$store.state.notification;
		}
	},
	mounted() {
		this.recordVisit();
	},
	methods: {
		async recordVisit() {
			const URL = "https://us-central1-counters-b.cloudfunctions.net/counter?id=teleretina";
			const LOCAL_DOMAINS = ["localhost", "127.0.0.1"];
	
			if (!LOCAL_DOMAINS.includes(window.location.hostname)) {
				let response = await fetch(URL);
	
				if (response.ok) {
					let json = await response.json();
					console.log(json);
				} else {
					console.log("HTTP-Error: " + response.status);
				}
			}
		}
	}
};
</script>

<style>
.v-list--nav .v-list-item:not(:last-child):not(:only-child),
.v-list--rounded .v-list-item:not(:last-child):not(:only-child) {
	margin-bottom: 0px;
}

.v-application--is-rtl .v-list-item__action,
.v-application--is-rtl .v-list-item__icon {
	margin-right: 32px !important;
	margin-left: 0 !important;
}

/* Make banner sticky in crappy iOS web browsers */
.v-application .v-banner--sticky {
	position: -webkit-sticky;
}
</style>
